import { useEffect, useCallback } from 'react';

interface ISessionItem {
  id: string;
  time: number;
}

let _sessionTimeout: any = null;
const sessionId = Math.random().toString(36).substring(2) + Date.now().toString(36);

export default function useSession() {
  const handleChange = useCallback((_e?: Event, visibility?: string) => {
    const now = Date.now();
    let sessionList = JSON.parse(localStorage.getItem('sessionList') || '[]').filter(
      (item: ISessionItem) => now - item.time < 1000 * 60 * 5,
    );
    clearTimeout(_sessionTimeout);
    if (
      visibility !== undefined ? visibility === 'hidden' : document.visibilityState === 'hidden'
    ) {
      sessionList = sessionList.filter((item: ISessionItem) => item.id !== sessionId);
    } else {
      const index = sessionList.findIndex((item: ISessionItem) => item.id === sessionId);
      if (index === -1) {
        sessionList.push({ id: sessionId, time: now });
      } else {
        sessionList[index].time = now;
      }
      _sessionTimeout = setTimeout(handleChange, 1000 * 60);
    }
    localStorage.setItem('sessionList', JSON.stringify(sessionList));
  }, []);

  const handleOffline = useCallback(() => {
    handleChange(undefined, 'hidden');
  }, []);

  useEffect(() => {
    handleChange();
    document.addEventListener('visibilitychange', handleChange);
    window.onbeforeunload = handleOffline;
    window.addEventListener('pagehide', handleOffline);
    window.addEventListener('unload', handleOffline);
    return () => {
      clearTimeout(_sessionTimeout);
      window.onbeforeunload = null;
      document.removeEventListener('visibilitychange', handleChange);
      window.removeEventListener('pagehide', handleOffline);
      window.removeEventListener('unload', handleOffline);
    };
  }, []);

  return {
    sessionId,
  };
}
